export const GAME_TITLE = process.env.REACT_APP_GAME_NAME!

export const WIN_MESSAGES = ['Bien hecho!', 'Fantástico!', 'Impresionante!']
export const GAME_COPIED_MESSAGE = 'Copiado al portapapeles'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Te faltan letras'
export const WORD_NOT_FOUND_MESSAGE = 'Nombre no encontrado'
export const HARD_MODE_ALERT_MESSAGE =
  'Hard Mode can only be enabled at the start!'
export const HARD_MODE_DESCRIPTION =
  'Any revealed hints must be used in subsequent guesses'
export const HIGH_CONTRAST_MODE_DESCRIPTION = 'For improved color vision'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `El nombre era ${solution}`
export const WRONG_SPOT_MESSAGE = (guess: string, position: number) =>
  `Must use ${guess} in position ${position}`
export const NOT_CONTAINED_MESSAGE = (letter: string) =>
  `Guess must contain ${letter}`
export const ENTER_TEXT = 'Probar'
export const DELETE_TEXT = 'Borrar'
export const STATISTICS_TITLE = 'Estadísticas'
export const GUESS_DISTRIBUTION_TEXT = 'Distribución'
export const NEW_WORD_TEXT = 'Siguiente nombre en'
export const SHARE_TEXT = 'Compartir'
export const TOTAL_TRIES_TEXT = 'Cantidad de intentos'
export const SUCCESS_RATE_TEXT = 'Rate de éxito'
export const CURRENT_STREAK_TEXT = 'Seguidila actual'
export const BEST_STREAK_TEXT = 'Mejor seguidilla'
